import APIClient from '../factories/APIClient'
import constructRequestData from '../../constructRequestData'

const client = new APIClient({
  baseURL: process.env.REACT_APP_IDENTITY_API_BASE_URL,
})

export const postDevices = body =>
  client({
    method: 'post',
    url: '/devices',
    data: constructRequestData(body),
  })
